// extracted by mini-css-extract-plugin
export default {"tileCont":"LastTileCont-module__tileCont--AHuhj"};